import React from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import cs from 'classnames';
import { useIsInboundVersion } from '../../hooks/useIsInboundVersion';
import { footerDataHooks as dataHooks } from './Footer.dataHooks';
import s from './Footer.scss';
import { useBiLogger } from '../../contexts/BILoggerContext';

export const Footer = () => {
  const { t } = useTranslation();
  const isInboundVer = useIsInboundVersion();
  const biLogger = useBiLogger();

  const marketplaceUrl =
    'https://www.wix.com/marketplace/templates?entry=templates-page&origin=templates-marketplace-banner';

  const onLinkClick = () => {
    const action = 'explore_marketplace';
    const action_value = isInboundVer ? undefined : 'start_creating_footer';

    biLogger.reportGeneralAction({ action, actionValue: action_value });
  };

  return (
    <div className={s.container}>
      <div
        className={cs(s.description, {
          [s.descriptionOutbound]: !isInboundVer,
        })}
      >
        <div className={s.descriptionText} data-hook={dataHooks.description()}>
          {t('app.new.footer.description.marketplace')}
        </div>
      </div>
      <a
        href={marketplaceUrl}
        className={s.wrapperLink}
        data-hook={dataHooks.link()}
        onClick={onLinkClick}
      >
        <div
          className={cs(s.buttonLabel, {
            [s.buttonLabelInbound]: isInboundVer,
          })}
          data-hook={dataHooks.linkLabel()}
        >
          {t('app.new.footer.buttonLabel.marketplace')}
        </div>
        <div className={s.button} />
      </a>
    </div>
  );
};
